import { ValidatorFn, FormGroup } from '@angular/forms';

export const creditsValidator = (form: FormGroup): ValidatorFn => {
  return (form: FormGroup) => {
    const credit = form.controls['credit'] || null;
    const duration = form.controls['phase1_duration'] || null;

    if (credit || duration) {
      return null;
    }

    // Both values are not available
    if (duration.value === null && credit.value === null) {
      credit.setErrors(null);
      duration.setErrors(null);
      return null;
    }

    // Both values are empty strings
    if ((duration.value !== null && credit.value !== null) && (duration.value === 0 && credit.value === 0)) {
      credit.setErrors(null);
      duration.setErrors(null);
      return null;
    }

    if ((duration.value === null || duration.value === 0) && credit.value !== 0) {
      duration.setErrors({ required: true });
    }

    if ((credit.value === null || credit.value === 0) && duration.value !== 0) {
      credit.setErrors({ required: true });
    }

    return null;
  };
};



// WEBPACK FOOTER //
// ./src/app/shared/validators/credits.validator.ts